<div class="blockcode pt-5">
    <div class="header">Default Accordion</div>
    <div class="description">Default Accordion</div>
    <CDBAccordion [data]='data'></CDBAccordion>
</div>
<div class="blockcode">
    <div class="header">Accordion without Icon</div>
    <div class="description">Accordion Without icon</div>
    <CDBAccordion [data]='data' [hideIcon]=true></CDBAccordion>
</div>